import { Box } from "@mui/material";
import { useState } from "react";
import { useHookFormContext } from "../../../../../utils/hooks/useHookFormContext";
import InviteMethodSelector from "./InviteMethodSelector";
import AgendaSelectionView from "./AgendaSelectionView";
import { InviteExpertFieldsProps } from "./type";
import { inputRowCommonStyles } from "../../../../../common/formStyles";
import { HookCheckBox } from "../../../../../atoms/form-fields/SLFieldCheckBox";


const InviteExpertFields = ({ agendas, agendaError, removeShareAgendOption = false }: InviteExpertFieldsProps) => {
  const { registerState, watch } = useHookFormContext();

  const shareAgendaValue = watch("share_agenda");
  const [selectedAgendaId, setSelectedAgendaId] = useState<number | null>(null);
  const isAgendaApplicable = agendas?.length > 0;

  if (agendaError) {
    return (
      <Box sx={{ padding: 2, textAlign: 'center', color: 'error.main' }}>
        Failed to load agenda data. Please try again.
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        paddingBottom: "1rem",
      }}
    >
      <InviteMethodSelector registerState={registerState} />

      {isAgendaApplicable && !removeShareAgendOption && (
        <Box sx={inputRowCommonStyles}>
          <HookCheckBox
            {...registerState("share_agenda")}
            label="Share Agenda with Expert"
          />
        </Box>
      )}

      {isAgendaApplicable && shareAgendaValue && (
        <AgendaSelectionView
          agendas={agendas}
          selectedAgendaId={selectedAgendaId}
          setSelectedAgendaId={setSelectedAgendaId}
        />
      )}
    </Box>
  );
};

export default InviteExpertFields;
